<div class="row">
  <div class="col-12">
      <div class="card">
          <div class="card-body">
              <!-- table start -->
              <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
                  [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
                  (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" (actionEmitter)="onTableAction($event)" [defaultPageSize]="5">
              </app-advanced-table>

              <div id="status" *ngIf="!loaded && !error">
                  <div class="spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                  </div>
              </div>

              <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
                  {{ error }}
              </ngb-alert>
          </div> <!-- end card body-->
      </div> <!-- end card -->
  </div><!-- end col-->
</div>
<!-- end row-->

